<template>
  <div class="home">
    <v-container>
      <v-layout>
        <v-tabs>
          <v-tab to="/scheduled/announcements" class="text-none">
            Announcements</v-tab
          >
          <v-tab to="/scheduled/exclusives" class="text-none">Exclusives</v-tab>
          <v-tab to="/scheduled/perks" class="text-none">Perks</v-tab>
          <v-tab to="/scheduled/pins" class="text-none">Pins</v-tab>
          <v-tab to="/scheduled/campaigns" class="text-none">Campaigns</v-tab>
          <v-tab to="/scheduled/data-stream" class="text-none"
            >Data Stream</v-tab
          >
          <v-tab to="/scheduled/chats" class="text-none">Chats</v-tab>
          <v-tab to="/scheduled/chat-stream" class="text-none"
            >Chat Stream</v-tab
          >
        </v-tabs>
      </v-layout>
      <v-divider />
      <router-view />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
  created() {
    if (this.$route.path === '/scheduled') {
      this.$router.push('/scheduled/announcements');
    }
  },
};
</script>
